module.exports = __webpack_public_path__ + "img/white_paper17.609d2f45.png";